import { DatePipe } from '@angular/common';
import { Image } from 'src/app/people/models/image';
import * as moment from 'moment';
import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import {
  ICustomFieldQueryModel,
  ComplexFieldQueryModel,
} from 'src/app/shared/components/odata-filter/models/custom-field-query.model';
import { IPersonRace } from 'src/app/people/models/personRace.model';
import { IPersonTag } from 'src/app/people/models/personTag.model';

export class TeamRostersReportModel {
  public seatId: string;
  public seatStatus: string;
  public seatUpdatedOn: Date;
  public teamId: string;
  public teamName: string;
  public teamStartDate: Date;
  public teamEndDate: Date;
  public teamUpdatedBy: string;
  public teamUpdatedOn: Date;
  public teamCreatedBy: string;
  public teamCreatedOn: Date;
  public teamStatus: string;
  public personId: string;
  public personName: string;
  public personEmail: string;
  public personExternalSystemId: string;
  public personStatus: string;
  public personImage: Image;
  public positionTitle: string;
  public personCustomFields: ICustomFieldQueryModel[] = [];
  public teamCustomFields: ICustomFieldQueryModel[] = [];
  public trackedCustomFields: ICustomFieldQueryModel[] = [];
  public personComplexCustomFields: ComplexFieldQueryModel[] = [];
  public races: IPersonRace[];
  public personTags: IPersonTag[];
  public gender: string;
  public teamWorkspaceId: string;
  public personIsUnsubscribed: string;
  private datePipe: DatePipe = new DatePipe(moment.locale());

  constructor(data: any) {
    if (!data) return null;

    Object.assign(this, data);
    this.personImage = new Image(data.personImageId);
    this.personIsUnsubscribed = data.personIsUnsubscribed ? 'UnSubscribed' : 'Subscribed';
    this.personCustomFields
      .filter((x) => x.dateRangeAttributeStartDateValue)
      .forEach((x) => {
        let dates = x.value.split('|');
        x.value = `${moment(dates[0]).format('MM/DD/YYYY')} - ${
          dates[1] != 'Present' ? moment(dates[1]).format('MM/DD/YYYY') : dates[1]
        }`;
      });
    this.teamCustomFields
      .filter((x) => x.dateRangeAttributeStartDateValue)
      .forEach((x) => {
        let dates = x.value.split('|');
        x.value = `${moment(dates[0]).format('MM/DD/YYYY')} - ${
          dates[1] != 'Present' ? moment(dates[1]).format('MM/DD/YYYY') : dates[1]
        }`;
      });
    this.trackedCustomFields
      .filter((x) => x.dateRangeAttributeStartDateValue)
      .forEach((x) => {
        let dates = x.value.split('|');
        x.value = `${moment(dates[0]).format('MM/DD/YYYY')} - ${
          dates[1] != 'Present' ? moment(dates[1]).format('MM/DD/YYYY') : dates[1]
        }`;
      });

    this.personComplexCustomFields = data.personComplexCustomFields?.map(
      (x) => new ComplexFieldQueryModel(x.id, x.name, x.values)
    );
  }

  get date(): string {
    if (!this.teamStartDate && !this.teamEndDate) {
      return '';
    }
    if (this.teamStartDate && !this.teamEndDate) {
      return `Started ${this.datePipe.transform(this.teamStartDate, 'mediumDate', 'utc')}`;
    }

    if (!this.teamStartDate && this.teamEndDate) {
      return `Ended ${this.datePipe.transform(this.teamEndDate, 'mediumDate', 'utc')}`;
    }

    return `${this.datePipe.transform(
      this.teamStartDate,
      'mediumDate',
      'utc'
    )} - ${this.datePipe.transform(this.teamEndDate, 'mediumDate', 'utc')}`;
  }
  get racesFlatValue(): string {
    return this.races ? this.races.map((x) => x.name).join('\n') : '';
  }
  get customFields(): ICustomFieldQueryModel[] {
    let customFields: ICustomFieldQueryModel[] = [];
    customFields = customFields.concat(
      this.personCustomFields,
      this.teamCustomFields,
      this.trackedCustomFields
    );
    return customFields;
  }
}

export class TeamRostersReportFilterResult implements FilterResult {
  public count: number;
  public values: any[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new TeamRostersReportFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((report) => new TeamRostersReportModel(report));
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}

export class TeamRostersChartNumbers {
  public seatIdCount: number;
  public uniqueTeamIdCount: number;
  public uniquePersonIdCount: number;
}
